import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { ProjectsListPage } from './ProjectsListPage'
import { CreateProjectPage } from './CreateProjectPage'

export const ProjectsPage: React.FC = () => {
  return (
    <Routes>
      <Route index element={<ProjectsListPage />} />
      <Route path="create" element={<CreateProjectPage />} />
      <Route path="edit/:id" element={<CreateProjectPage />} />
      <Route path=":id" element={<ProjectsListPage />} />
    </Routes>
  )
}